import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { SlideFrame } from '../SlideFrame';
import { calendarMonths, calendarRows, campaignArcs } from '../../data/deckContent';
export function RhythmSlide() {
  const reduced = useReducedMotion();
  return <SlideFrame eyebrow="The rhythm" index={10} chapter="tactics" data-id="element-177" data-mp="2ys1hf9zmly00">
      <div data-id="element-178" data-mp="2yrrrtnihtsuu">
        <div className="flex items-end justify-between gap-[3vw]" data-id="element-179" data-mp="2ypxh120xrh4h">
          <h2 className="text-[clamp(18px,2.5vw,45px)] font-semibold leading-[1.1] tracking-tight text-white" data-id="element-180" data-mp="2ttq8d1h5nriu">
            A year of small investments.
            <br data-id="element-181" data-mp="2ks0ii02x90n6" />
            <span className="text-[color:var(--sv-green)]" data-id="element-182" data-mp="2krqtoftm4zj2">
              A year of meaningful paybacks.
            </span>
          </h2>
          <span className="shrink-0 text-[clamp(8px,0.72vw,13px)] uppercase tracking-[0.3em] text-white/25" data-id="element-183" data-mp="2fuqnm4wrjwry">
            Illustrative · not agreed dates
          </span>
        </div>

        <div className="mt-[3vh]" data-id="element-184" data-mp="e342gjzjyw3e">
          <div className="grid grid-cols-[1.15fr_repeat(7,1fr)] gap-x-[0.7vw] border-b border-white/12 pb-[0.9vh]" data-id="element-185" data-mp="dzzq2zbxou1n">
            <span className="text-[clamp(8px,0.72vw,13px)] uppercase tracking-[0.26em] text-white/40" data-id="element-186" data-mp="2hhwnb43o1p61">
              Product
            </span>
            {calendarMonths.map(month => <span key={month} className="text-[clamp(8px,0.72vw,13px)] uppercase tracking-[0.26em] text-white/40" data-id="element-187" data-mp="28h6xqi500v0r">
                {month}
              </span>)}
            <span className="text-[clamp(8px,0.72vw,13px)] uppercase tracking-[0.26em] text-white/20" data-id="element-188" data-mp="316dtj9d2j6ib">
              …
            </span>
          </div>

          {calendarRows.map((row, rowIndex) => <div key={row.product} className="grid grid-cols-[1.15fr_repeat(7,1fr)] items-center gap-x-[0.7vw] border-b border-white/[0.07] py-[1.1vh]" data-id="element-189" data-mp="2rfaued3p91lo" data-mpi={rowIndex}>
              <span className="text-[clamp(9px,0.95vw,18px)] font-medium text-white" data-id="element-190" data-mp="3jwvnfh9n0859">
                {row.product}
              </span>
              {row.cells.map((cell, cellIndex) => cell ? <motion.span key={`${row.product}-${cellIndex}`} initial={reduced ? false : {
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.3,
            delay: 0.04 * (rowIndex + cellIndex),
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex items-center gap-[0.4vw] rounded-full border px-[0.7vw] py-[0.7vh] text-[clamp(7px,0.72vw,13px)] font-medium leading-none ${cell.opening ? 'border-[color:var(--sv-green)]/55 bg-[color:var(--sv-green)]/12 text-[color:var(--sv-green)]' : 'border-white/12 bg-white/[0.04] text-white/70'}`} data-id="element-191" data-mp="3ouaq5py3oeh7">
                    <svg aria-hidden="true" viewBox="0 0 20 20" className="h-[0.9em] w-[0.9em] shrink-0 -rotate-90" data-id="element-192" data-mp="2n69oehqt809f">
                      <circle cx="10" cy="10" r="8" fill="none" stroke="currentColor" strokeOpacity="0.28" strokeWidth="2.5" data-id="element-193" data-mp="17msluqfwehc4" />
                      <circle cx="10" cy="10" r="8" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeDasharray="50.2" strokeDashoffset={cell.opening ? 12 : 25} data-id="element-194" data-mp="nwp60ubp854u" />
                    </svg>
                    <span className="truncate" data-id="element-195" data-mp="54o0xa8bzimz">{cell.label}</span>
                  </motion.span> : <span key={`${row.product}-${cellIndex}`} aria-hidden="true" className="h-[1px] bg-white/[0.06]" data-id="element-196" data-mp="27qrzbz64ynxh" />)}
              <span aria-hidden="true" className="h-[1px] bg-white/[0.06]" data-id="element-197" data-mp="2buzn9u4rrzun" />
            </div>)}
        </div>

        <div className="mt-[2.6vh] flex flex-wrap items-start gap-x-[3vw] gap-y-[1vh]" data-id="element-198" data-mp="2qiuh5duika9b">
          <p className="text-[clamp(9px,0.9vw,17px)] font-light text-white/40" data-id="element-199" data-mp="2ll2k65f0hxy9">
            One product does not equal one campaign.
          </p>
          {campaignArcs.map(arc => <p key={arc.product} className="text-[clamp(9px,0.9vw,17px)] font-light text-white/70" data-id="element-200" data-mp="2vj06uoh83mor">
              <span className="font-medium text-white" data-id="element-201" data-mp="156t3zykxbfii">{arc.product}</span>{' '}
              <span className="text-white/45" data-id="element-202" data-mp="115r3lef9sxey">
                {arc.arc.join(' → ')}
              </span>
            </p>)}
        </div>

        <p className="mt-[2.4vh] text-[clamp(12px,1.5vw,29px)] font-light text-white" data-id="element-203" data-mp="r34y55ffrq0z">
          Same product.{' '}
          <span className="font-medium text-[color:var(--sv-green)]" data-id="element-204" data-mp="hazau904pws4">
            New reason to engage.
          </span>
        </p>
      </div>
    </SlideFrame>;
}